module.exports = __webpack_public_path__ + "static/media/permisos-geolocalizacion.363310c4.webp";